export interface AppConfig {
  production: boolean;

  api_url: string;
  hrologin_url: string;
  lib_base: string;
  swfurl: string;
  documenturl: string;
  downloadUrl: string;
  surveydownloadUrl: string;
  downloadMultiSurvey: string;
  downloadPatientDocuments: string;
  videoDescriptionurl: string;
  pdfdocumenturl: string;
  downloadcare: string;
  practiceid: number;
  imagefileSize: number;
  idletime: number;
  timeset: number;
  timelimit: number;
  demositesetup: boolean;
  ipBlocked: boolean;
  dateFormat: string;
  dateForm: string;
  vmImageURL: string;
  cloudeImageURL: string;
  onboardImageURL: string;
  directobgin_url: string;
  OpBodyPart: string;
  version: string;
}
export const environment: AppConfig = {
  production: false,

  api_url: '',
  hrologin_url: '',
  lib_base: '',
  swfurl: '',
  documenturl: '',
  downloadUrl: '',
  surveydownloadUrl: '',
  downloadMultiSurvey: '',
  downloadPatientDocuments: '',
  videoDescriptionurl: '',
  pdfdocumenturl: '',
  downloadcare: '',
  practiceid: 0,
  imagefileSize: 0,
  idletime: 0,
  timeset: 0,
  timelimit: 0,
  demositesetup: false,
  ipBlocked: false,
  dateFormat: '',
  dateForm: '',
  vmImageURL: '',
  cloudeImageURL: '',
  onboardImageURL: '',
  directobgin_url: '',
  OpBodyPart: '',
  version: ''
};